import './Footer.css'
const Footer =()=>{
    return(
        <div className='Footer'>
            <p className='textFooter'>Created by Adrian Lemos 2022</p>
        </div>
    )

}

export default Footer